<template>
  <PageContainer>
    <h1 class="text-center mb-6">Welcome {{ username }}</h1>
    <p class="text-center mb-12">
      Please update your password to start using the app
    </p>

    <v-row>
      <v-col class="mb-8">
        <div class="d-flex justify-center justify-lg-end">
          <v-form style="width: 500px">
            <v-text-field
              :disabled="loading"
              filled
              prepend-inner-icon="mdi-lock"
              placeholder="Your new password"
              type="password"
              v-model="password"
              @keyup.enter="onEnterKeyPressed"
            >
            </v-text-field>

            <v-text-field
              :disabled="loading"
              filled
              prepend-inner-icon="mdi-lock"
              placeholder="Confirm your new password"
              type="password"
              v-model="passwordConfirm"
              @keyup.enter="onEnterKeyPressed"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              :disabled="!isFormValid || loading"
              :loading="loading"
              block
              class="font-weight-regular text-capitalize px-16"
              @click="onChangePasswordClicked"
            >
              Change Password
            </v-btn>
          </v-form>
        </div>
      </v-col>
      <v-col>
        <div class="d-flex justify-center justify-lg-start ps-lg-8">
          <v-card width="500px">
            <v-alert
              style="
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
              "
              type="info"
            >
              Your password must contain the following:
            </v-alert>
            <div class="px-4 pb-4">
              <ul>
                <li>At least 6 characters</li>
              </ul>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </PageContainer>
</template>

<script>
import api from "../../api";
import { navigation } from "../../router";
import storage from "../../storage";
import toasts from "../../utils/toasts";
export default {
  data() {
    return {
      password: "",
      passwordConfirm: "",
      loading: false,
    };
  }, // data

  computed: {
    isFormValid() {
      return (
        this.password != null &&
        this.password.trim().length >= 6 &&
        this.passwordConfirm != null &&
        this.passwordConfirm.trim().length >= 6 &&
        this.password == this.passwordConfirm
      );
    },

    username() {
      return storage.local.getEmail();
    },
  }, // computed

  methods: {
    onEnterKeyPressed() {
      return; //This prevents auto calling the passsword change request.
      // if (!this.isFormValid) return;
      // this.changePasswordAsync();
    },

    onChangePasswordClicked() {
      if (!this.isFormValid) return;
        this.changePasswordAsync();
    },

    async changePasswordAsync() {
      if (!this.isFormValid) return;

      this.loading = true;

      try {
        await api.users.changePasswordAsync(
          this.password,
          this.passwordConfirm
        );

        toasts.success("Password changed successfully");
        this.$router.push(navigation.main.passwordChanged.index);
      } catch (error) {
          toasts.error(`Could not change password. ${error}`);
      } finally {
          this.loading = false;
      }
    },
  }, // methods
};
</script>

<style>
</style>
